import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData, patchData, postData } from "src/utils/axios/serverHelper";
import { formatDate } from "src/utils/string/stringUtil";
import {
	KSK1110_R01DetailDto,
	KSK1110_R01Dto,
	KSK1110_R01HeaderDto,
} from "./Dto_KSK1110_R01";
import { KSK1110_R01Filter } from "./Store_KSK1110_R01";

const baseUrl = `${config.apiUrl}/KSK1110_R01`;

export interface KSK1110_R01ListParams {
	startDate?: string;
	endDate?: string;
	inoutClass?: "110" | "170";
	includeCompleted?: boolean;
}

export const getKSK1110_R01Params = (
	filter: Partial<KSK1110_R01Filter>,
): KSK1110_R01ListParams => ({
	startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
	endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
	inoutClass: filter.inoutClass || undefined,
	includeCompleted: filter.includeCompleted ?? false,
});

export const getKSK1110_R01List = async (
	option: "search" | "refetch",
	filter: Partial<KSK1110_R01Filter>,
) => getData<ResponseDto<KSK1110_R01HeaderDto[]>>(
	`${baseUrl}/${option}`,
	{ params: getKSK1110_R01Params(filter) },
);

export const getKSK1110_R01AllCount = async (filter: Partial<KSK1110_R01Filter>) =>
	getData<ResponseDto<number>>(
		`${baseUrl}/allCount`,
		{ params: getKSK1110_R01Params(filter) },
	);

export const getKSK1110_R01DetailList = async (transportNo: string, itemNo: string) =>
	getData<ResponseDto<KSK1110_R01DetailDto[]>>(
		`${baseUrl}/detail/${encodeURIComponent(transportNo)}/${encodeURIComponent(itemNo)}`,
	);

export const postKSK1110_R01 = async (data: KSK1110_R01Dto) =>
	postData<KSK1110_R01Dto, ResponseDto<KSK1110_R01Dto>>(baseUrl, data);

export const patchKSK1110_R01 = async (data: KSK1110_R01Dto) =>
	patchData<KSK1110_R01Dto, ResponseDto<KSK1110_R01Dto>>(baseUrl, data);
